/// <reference path="DOMAttached.js" />

class NewspaperAd extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		if (this.options.isInPreviewMode) {
			this.initializeChangeHandlers();
		}
	}

	initializeChangeHandlers() {
		this.titleText = this.el.querySelector('.titleText');
		this.bodyText = this.el.querySelector('.bodyText');

		this.titleBoundTextArea = document.getElementById(this.options.textBoxTitleId).querySelector('textarea');
		this.bodyBoundTextArea = document.getElementById(this.options.textBoxBodyId).querySelector('textarea');
		this.boundImageContainer = document.getElementById(this.options.pictureSelection).querySelector('.imageShow');

		this.safeObserve(this.titleBoundTextArea, 'change', this.onTitleChange.bind(this));

		this.safeObserve(this.bodyBoundTextArea, 'change', this.onBodyChange.bind(this));
	}

	onTitleChange(ev) {
		this.titleText.innerHTML = this.titleBoundTextArea.value;
	}

	onBodyChange(ev) {
		this.bodyText.innerHTML = this.bodyBoundTextArea.value;
	}
}
